export { default } from './TableRow';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/TableRow/index.js
// module id = 564
// module chunks = 2